import { createSelector } from "reselect";
import { isEmpty, map } from "lodash";

const getData = state => {
  const images = state.user.images;
  if (isEmpty(images)) {
    return [];
  }

  let updatedImages = map(images, image => ({
    id: image.id,
    src: image.image,
    thumbnail: image.thumbnail,
    thumbnailWidth: 320,
    thumbnailHeight: 212
  }));
  return updatedImages;
};

const getGalleryImages = createSelector(getData, images => images);
export default getGalleryImages;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getGalleryImages.js